import { useContext } from "react";
import { authContext } from "../session/authContext";

export function useLogout() {
  const context = useContext(authContext);
  if (!context) {
    throw new Error("AuthContext not initialised");
  }
  return context.client.logout.bind(context.client);
}
